module.exports = __webpack_public_path__ + "static/award8-496addf8db9778c5156b86674e9588f3.png";